<template>
  <div class="modify-password">
    <p class="title">
      修改密码
    </p>
    <div class="item">
      <p class="label required">
        旧密码
      </p>
      <van-field
        class="input"
        type="password"
        v-model="old_password"
        placeholder="请输入旧密码"
      />
    </div>

    <div class="item">
      <p class="label required">
        新密码
      </p>
      <van-field
        class="input"
        type="password"
        v-model="new_password"
        placeholder="请输入新密码"
      />
    </div>

    <div class="item">
      <p class="label required">
        确认密码
      </p>
      <van-field
        class="input"
        type="password"
        v-model="confirm_password"
        placeholder="请确认密码"
      />
    </div>

    <div class="btns">
       <van-button class="confirm" type="primary" @click="save">保存</van-button>
    </div>
  </div>
</template>

<script>
import {
  modifyPassword
} from '@/api/system';
import {
  userTokenKey
} from '@/config/index';
export default {
  name: 'ModifyPassword',
  data() {
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
    }
  },
  methods: {
    save() {
      const {
        old_password,
        new_password,
        confirm_password
      } = this

      if (!old_password || !new_password || !confirm_password) {
        this.$Toast.fail('必填项不可为空')
        return
      }

      const params = {
        old_password,
        new_password,
        confirm_password
      }
      modifyPassword(params)
      .then(res => {
        if (res) {
          this.$Toast.success('修改成功，请重新登录')
          this.$cookie.remove(userTokenKey)
          this.$router.replace('/login')
        }
      })
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
  .modify-password {
    .title {
      margin: 94px 0;
      padding: 0 106px;
      font-size: 48px;
      color: @font-black-1;
      font-weight: bold;
    }
    .item {
      padding: 0 106px;
      display: flex;
      align-items: center;
      &:not(:last-child) {
        margin: 0 0 44px 0;
      }
      .label {
        width: 200px;
        margin: 0 26px 0 0;
        font-size: 42px;
        color: @font-black-2;
      }
      .input {
        flex: 1;
        border-radius: 4px;
        background-color: rgba(254, 254, 254, 0.3);
        box-shadow: 0px 0px 2px 1px rgba(68, 208, 201, 0.35);
        /deep/ input {
          &::placeholder {
            color: @font-gray-3;
          }
        }
      }
    }

    .required {
      &::before {
        content: '*';
        color: red;
        vertical-align: middle;
      }
    }

    .btns {
      display: flex;
      justify-content: center;
      margin: 114px 0 0;
      .confirm {
        width: 278px;
        height: 110px;
        border-radius: 6px;
        background-image: linear-gradient(135deg, @primary-color-5, @primary-color-1);
        border: none;
        font-weight: bold;
      }
    }
  }
</style>